function displayToggleHandler() {
    // @ts-expect-error
    let rows = document.querySelectorAll(this.getAttribute('data-target'));
    for (let i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('d-none');
    }
    // @ts-expect-error
    let toggle = this.querySelector('.display-toggle-indicator');
    toggle.classList.toggle('bi-chevron-down');
    toggle.classList.toggle('bi-chevron-up');
    toggle.classList.toggle('text-primary');
}

(window as any).displayToggle = displayToggle
export function displayToggle(el) {
    el.addEventListener('click', displayToggleHandler)
}

window.addEventListener('load', () => {
    let els = document.getElementsByClassName('display-toggle');
    for (let i = 0; i < els.length; i++) {
        els[i].addEventListener('click', displayToggleHandler);
    }
});